import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SessionProvider } from './context/SessionContext';
import { AppDialogProvider } from './context/AppDialogContext';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <SessionProvider>
        <AppDialogProvider>
          <App />
        </AppDialogProvider>
      </SessionProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
